var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastEventIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F0B64B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41096 4.83301H9.52471C10.886 4.83301 11.5664 4.83301 12.0393 5.16551C12.1747 5.26051 12.2951 5.37384 12.3964 5.50092C12.7505 5.94509 12.7505 6.58426 12.7505 7.86342V8.92384C12.7505 10.1584 12.7505 10.7759 12.5547 11.2688C12.2397 12.0618 11.5743 12.6868 10.7305 12.9826C10.206 13.1663 9.54888 13.1663 8.23471 13.1663C7.48388 13.1663 7.10846 13.1663 6.80846 13.0613C6.32638 12.8922 5.94596 12.5351 5.7668 12.0822C5.6543 11.8005 5.6543 11.4476 5.6543 10.7422V8.99967",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.99967C12.75 9.36799 12.6037 9.72123 12.3433 9.98167C12.0828 10.2421 11.7296 10.3884 11.3613 10.3884C11.0838 10.3884 10.7567 10.3401 10.4871 10.4122C10.3694 10.4438 10.262 10.5059 10.1758 10.5921C10.0896 10.6783 10.0275 10.7857 9.99586 10.9034C9.92377 11.173 9.97211 11.5001 9.97211 11.7776C9.97211 11.96 9.93619 12.1406 9.86639 12.309C9.7966 12.4775 9.69431 12.6306 9.56535 12.7596C9.43639 12.8885 9.2833 12.9908 9.11481 13.0606C8.94632 13.1304 8.76573 13.1663 8.58336 13.1663M8.57127 8.17509C8.57127 7.11717 8.62669 6.62176 7.94086 6.13092C7.60377 5.88926 6.48419 5.80217 5.56836 5.88801M6.29252 4.83301L5.31044 5.71217C5.27134 5.75106 5.24926 5.80386 5.24903 5.859C5.24879 5.91414 5.27043 5.96712 5.30919 6.00634L6.29252 6.93592",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastEventIcon);
export default __webpack_public_path__ + "static/media/PastEventIcon.fa85f0ad695f39b7509e1a28b147c804.svg";
export { ForwardRef as ReactComponent };